export const MULTILINGUAL_ENABLED =
  process.env["REACT_APP_MULTILINGUAL_ENABLED"] === "true";
